import { fork } from "redux-saga/effects";

import { helloSaga } from "./Layout/Layout.saga";
import Notice from "./Notice/Notice.saga";

export default function* root() {
  yield fork(helloSaga);
  yield fork(Notice);
}
